import * as React from "react"

interface IconNameProps {
  fill: string
}

export const IconName = ({ fill: fill }: IconNameProps) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 80 144.3"
    xmlSpace="preserve"
    width="70"
    height="144"
  >
    <g>
      <path
        fill={fill}
        d="M58,8.3c0-4.2,3.8-7.6,8.5-7.6c4.8,0,8.5,3.4,8.5,7.6c0,4.8-4.5,6.6-4.5,6.6l-1.4-2.7c0,0,3-1.3,3-3.9
		c0-2.4-2.7-4.4-5.6-4.4S60.9,6,60.9,8.3c0,2.7,3,4,3,4L62.5,15C62.5,15,58,13.1,58,8.3z"
      />
      <path
        fill={fill}
        d="M59.8,26.3c0,0-1.7-1.5-1.7-4.2c0-3.4,2.8-6.1,6.2-6.1s6.2,2.8,6.2,6.1c0,1.6-0.6,3-1.6,4.1h-3.9H63v-7.4
		c-1.3,0.5-2.3,1.8-2.3,3.3s0.8,2.1,0.8,2.1L59.8,26.3z M65.3,18.8v4.8h2.1c0.2-0.4,0.3-0.9,0.3-1.5C67.6,20.6,66.6,19.3,65.3,18.8z
		"
      />
      <path
        fill={fill}
        d="M68.3,38.5h-10v-3h8.9c0.2-0.4,0.4-0.9,0.4-1.4c0-1.5-1.3-2.8-2.8-2.8h-6.4v-2.9h11.7v2.7l-1.3,0.3
		c1,0.7,1.6,1.8,1.6,3.2C70.4,36.2,69.7,37.7,68.3,38.5z"
      />
      <path
        fill={fill}
        d="M67.4,44.2h-5.1c-0.7,0-1.2,0.5-1.2,1.2v0.9h-2.7v-1.4c0-1.9,1.6-3.6,3.5-3.6h5.5v-1.5h2.7v0.8
		c0,0.5,0.4,0.9,0.9,0.9h2.3v2.7H70v2.7h-2.7v-2.7H67.4z"
      />
      <path
        fill={fill}
        d="M70.2,55.4h-2.7v-0.8c0-2.3-1.2-3-2.8-3h-6.2v-3h11.7v2.7l-1.4,0.4c0.8,0.5,1.4,1.2,1.4,2.3V55.4z"
      />
      <path
        fill={fill}
        d="M59.8,66.2c0,0-1.7-1.5-1.7-4.2c0-3.4,2.8-6.1,6.2-6.1s6.2,2.8,6.2,6.1c0,1.6-0.6,3-1.6,4.1h-3.9H63v-7.4
		c-1.3,0.5-2.3,1.8-2.3,3.3s0.8,2.1,0.8,2.1L59.8,66.2z M65.3,58.7v4.8h2.1c0.2-0.4,0.3-0.9,0.3-1.5C67.6,60.5,66.6,59.2,65.3,58.7z
		"
      />
      <path
        fill={fill}
        d="M70.2,79.8h-2.7V77h-9v-2.9h9v-1.5h2.7v1.5h1.4c1.9,0,3.5,1.6,3.5,3.6v1.4h-2.7v-0.9c0-0.7-0.5-1.2-1.2-1.2
		h-1.1L70.2,79.8L70.2,79.8z"
      />
      <path
        fill={fill}
        d="M64.2,80.2c3.5,0,6.2,2.8,6.2,5.8s-2.7,5.8-6.2,5.8C60.8,91.8,58,89,58,86C58,83,60.8,80.2,64.2,80.2z
		 M64.2,88.9c1.9,0,3.3-1.2,3.3-2.9c0-1.7-1.4-2.9-3.3-2.9c-1.9,0-3.3,1.2-3.3,2.9C60.9,87.7,62.3,88.9,64.2,88.9z"
      />
      <path
        fill={fill}
        d="M70.2,100.4h-2.7v-0.8c0-2.3-1.2-3-2.8-3h-6.2v-3h11.7v2.7l-1.4,0.4c0.8,0.5,1.4,1.2,1.4,2.3V100.4z"
      />
    </g>
    <g>
      <path
        fill={fill}
        d="M31.4,8.3c0-4.2,3.8-7.6,8.5-7.6c4.8,0,8.5,3.4,8.5,7.6c0,4.8-4.5,6.6-4.5,6.6l-1.4-2.7c0,0,3-1.3,3-3.9
		c0-2.4-2.7-4.4-5.6-4.4c-2.9,0-5.6,2.1-5.6,4.4c0,2.7,3,4,3,4L35.9,15C35.9,15,31.4,13.1,31.4,8.3z"
      />
      <path
        fill={fill}
        d="M37.6,16c3.5,0,6.2,2.8,6.2,5.8s-2.7,5.8-6.2,5.8c-3.4,0-6.2-2.8-6.2-5.8C31.4,18.8,34.2,16,37.6,16z
		 M37.6,24.7c1.9,0,3.3-1.2,3.3-2.9c0-1.7-1.4-2.9-3.3-2.9s-3.3,1.2-3.3,2.9S35.8,24.7,37.6,24.7z"
      />
      <path
        fill={fill}
        d="M41.8,39.5h-9.9v-3h8.9c0.2-0.4,0.4-0.9,0.4-1.4c0-1.5-1.3-2.8-2.8-2.8h-6.5v-2.9h11.7v2.7l-1.3,0.3
		c1,0.7,1.6,1.8,1.6,3.2C43.8,37.1,43,38.6,41.8,39.5z"
      />
      <path
        fill={fill}
        d="M40.8,45.1h-5.1c-0.7,0-1.2,0.5-1.2,1.2v0.9h-2.7v-1.4c0-1.9,1.6-3.6,3.5-3.6h5.5v-1.5h2.7v0.8
		c0,0.5,0.4,0.9,0.9,0.9h2.3v2.7h-3.3v2.7h-2.6V45.1z"
      />
      <path
        fill={fill}
        d="M33.1,58.9c0,0-1.7-1.5-1.7-4.2c0-3.4,2.8-6.1,6.2-6.1s6.2,2.8,6.2,6.1c0,1.6-0.6,3-1.6,4.1h-3.9h-1.9v-7.4
		c-1.3,0.5-2.3,1.8-2.3,3.3s0.8,2.1,0.8,2.1L33.1,58.9z M38.8,51.4v4.8h2.1c0.2-0.4,0.3-0.9,0.3-1.5C41,53.2,40,51.9,38.8,51.4z"
      />
      <path
        fill={fill}
        d="M41.8,76.6h-9.9v-2.9h8.9C41,73.4,41,73,41,72.6c0-1.2-1-2.2-2.2-2.2l0,0h-7v-2.9h8.9c0.2-0.4,0.3-0.7,0.3-1.2
		c0-1.2-1-2.2-2.2-2.2h-7V61h11.7v2.7L42.3,64c0.9,0.6,1.5,1.5,1.5,2.9c0,1.3-0.6,2.4-1.6,3.1c0.9,0.7,1.6,1.8,1.6,3.1
		C43.8,74.6,43,75.9,41.8,76.6z"
      />
      <path
        fill={fill}
        d="M37.6,90.2c-3.5,0-6.2-2.1-6.2-5.1c0-1.4,0.6-2.4,1.6-3.1h-5.9v-3h16.4v2.6L42.3,82c1,0.7,1.5,1.7,1.5,3.1
		C43.8,88.1,41,90.2,37.6,90.2z M37.6,87.2c1.9,0,3.4-1,3.4-2.7s-1.5-2.7-3.4-2.7c-1.9,0-3.4,1-3.4,2.7S35.8,87.2,37.6,87.2z"
      />
      <path
        fill={fill}
        d="M37.6,91.2c3.5,0,6.2,2.8,6.2,5.8s-2.7,5.8-6.2,5.8c-3.4,0-6.2-2.8-6.2-5.8C31.4,94,34.2,91.2,37.6,91.2z
		 M37.6,99.9c1.9,0,3.3-1.2,3.3-2.9s-1.4-2.9-3.3-2.9s-3.3,1.2-3.3,2.9S35.8,99.9,37.6,99.9z"
      />
      <path
        fill={fill}
        d="M43.4,111.4h-2.6v-0.8c0-2.3-1.2-3-2.8-3h-6.2v-3h11.7v2.7l-1.4,0.4c0.8,0.5,1.4,1.2,1.4,2.3v1.4H43.4z"
      />
      <path
        fill={fill}
        d="M34.4,123.4h-2.6v-0.7c0-1.1,0.5-2.1,1.3-2.7c-1-0.7-1.6-2-1.6-3.4c0-1.8,0.7-2.9,1.9-4h3.9
		c0.9,0.7,1.3,2.5,1.5,4c0.4,2.5,1,2.6,1.4,2.6c0.7,0,1.1-0.8,1.1-2.1c0-2-1.5-2.5-1.5-2.5l1.3-2.3c1.6,0.8,2.7,2.1,2.7,4.8
		c0,3.3-1.5,5-4,5h-4.1C35,122.1,34.5,122.6,34.4,123.4L34.4,123.4L34.4,123.4z M36.2,119.1h1c-0.7-1.1-0.5-2.9-1.1-3.9h-1.5
		c-0.4,0.5-0.6,1.1-0.6,1.8C33.9,118.2,34.5,119.1,36.2,119.1z"
      />
      <path
        fill={fill}
        d="M43.4,131.9h-2.6v-0.8c0-2.3-1.2-3-2.8-3h-6.2v-3h11.7v2.7l-1.4,0.4c0.8,0.5,1.4,1.2,1.4,2.3v1.4H43.4z"
      />
      <path
        fill={fill}
        d="M31.3,140.3c-3.8-1.3-4.2-2.9-4.2-4.9V134h2.6v0.8c0,0.8,0.2,1.9,2.1,2.5l11.7-4.9v3.2l-8,3.2l8,2.3v3.2
		C39.4,143,33.3,140.9,31.3,140.3z"
      />
    </g>
    <g>
      <path
        fill={fill}
        d="M9,10.4V4.6L5.2,3.3V0l16.4,5.6v3.1v0.6L5.2,15v-3.3L9,10.4z M11.8,9.5l6-2l-6-2V9.5z"
      />
      <path
        fill={fill}
        d="M14.7,19.8c0-0.7-0.4-1.2-0.9-1.2s-0.9,0.3-1.1,0.9l-0.9,2.1c-0.5,1.3-1.4,2.6-3.5,2.6c-2,0-3.5-1.7-3.5-4.3
		c0-3.7,2.7-4.6,2.7-4.6l1.3,2.6c0,0-1.4,0.4-1.4,1.8c0,1.1,0.5,1.5,1,1.5s0.9-0.3,1.3-1.1l0.7-1.8c0.7-1.9,2-2.6,3.6-2.6
		s3.2,1.6,3.2,3.9c0,3-2.5,4.2-2.5,4.2l-1.4-2.3C13.2,21.4,14.7,20.9,14.7,19.8z"
      />
      <path
        fill={fill}
        d="M20.2,25.5c1,0,1.9,0.8,1.9,1.9c0,1-0.8,1.9-1.9,1.9s-1.9-0.8-1.9-1.9C18.4,26.4,19.2,25.5,20.2,25.5z
		 M16.8,28.9v-3H5.2v3H16.8z"
      />
      <path
        fill={fill}
        d="M7.8,41.7H5.2V41c0-1.1,0.5-2.1,1.3-2.7c-1-0.7-1.6-2-1.6-3.4c0-1.8,0.7-2.9,1.9-4h3.9c0.9,0.7,1.3,2.5,1.5,4
		c0.4,2.5,1,2.6,1.4,2.6c0.7,0,1.1-0.8,1.1-2.1c0-2-1.5-2.5-1.5-2.5l1.3-2.3c1.6,0.8,2.7,2.1,2.7,4.8c0,3.3-1.5,5-4,5H9
		c-0.6,0-1.2,0.6-1.2,1.2V41.7z M9.5,37.5h1c-0.7-1.1-0.5-2.9-1.1-3.9H7.9c-0.4,0.5-0.6,1.1-0.6,1.8C7.3,36.5,7.9,37.5,9.5,37.5z"
      />
      <path
        fill={fill}
        d="M15.1,53.5h-10v-3H14c0.2-0.4,0.4-0.9,0.4-1.4c0-1.5-1.3-2.8-2.8-2.8H5.2v-2.9h11.6v2.7l-1.3,0.3
		c1,0.7,1.6,1.8,1.6,3.2C17.2,51.2,16.3,52.7,15.1,53.5z"
      />
      <path
        fill={fill}
        d="M9,70.6v-5.8l-3.9-1.3v-3.3l16.4,5.6v3.1v0.6L5.2,75.2v-3.3L9,70.6z M11.8,69.7l6-2l-6-2V69.7z"
      />
      <path
        fill={fill}
        d="M16.8,83.1h-2.7v-0.8c0-2.3-1.2-3-2.8-3H5.2v-3h11.6V79l-1.4,0.4c0.8,0.5,1.4,1.2,1.4,2.3V83.1z"
      />
      <path
        fill={fill}
        d="M14.1,88.2H9c-0.7,0-1.2,0.5-1.2,1.2v0.9H5.2v-1.4c0-1.9,1.6-3.6,3.5-3.6h5.5v-1.5h2.6v0.8
		c0,0.5,0.4,0.9,0.9,0.9H20v2.7h-3.2v2.7h-2.7V88.2z"
      />
    </g>
  </svg>
)
